import gql from 'graphql-tag';

import client from '../graphqlAPI';

const POST_ADD_ARTIST_SET_MUTATION = gql`
  mutation Post(
    $artistName: String
    $artistSetName: String
    $artistSetReadableName: ObjectLocalizationInput
    $artistSlugName: String
    $artistSetSlugName: String!
    $artistReadableName: ObjectLocalizationInput
    $countryCode: String
    $dateTimeEndReal: String
    $dateTimeStartReal: String
    $dateTimeStartHuman: String
    $artistSetGenres: [String]
    $duration: Int
    $image: ObjectLocalizationInput
    $mediaLinks: MediaLinksInput
    $postUri: String
    $shortTitle: ObjectLocalizationInput
    $show: Boolean
    $smallText: ObjectLocalizationInput
    $venueSlugName: String
    $stock: Int
    $timezone: String
  ) {
    postAddArtistSet(
      artistName: $artistName
      artistSetName: $artistSetName
      artistSetGenres: $artistSetGenres
      artistSetReadableName: $artistSetReadableName
      artistSlugName: $artistSlugName
      artistSetSlugName: $artistSetSlugName
      artistReadableName: $artistReadableName
      countryCode: $countryCode
      dateTimeEndReal: $dateTimeEndReal
      dateTimeStartReal: $dateTimeStartReal
      dateTimeStartHuman: $dateTimeStartHuman
      duration: $duration
      image: $image
      mediaLinks: $mediaLinks
      postUri: $postUri
      shortTitle: $shortTitle
      show: $show
      smallText: $smallText
      venueSlugName: $venueSlugName
      stock: $stock
      timezone: $timezone
    ) {
      isAuth
      isAdded
      artistSetSlugName
    }
  }
`;

const postAddArtistSet = async ({
  artistName, artistSetName, artistSetReadableName, artistSlugName, artistSetSlugName, artistReadableName, countryCode, dateTimeEndReal,
  dateTimeStartReal, dateTimeStartHuman, duration, image, mediaLinks, postUri, shortTitle, show, smallText, venueSlugName, artistSetGenres, stock,
  timezone,
}) => {
  try {
    const result = await client
      .mutate({
        mutation: POST_ADD_ARTIST_SET_MUTATION,
        variables: {
          artistName,
          artistSetName,
          artistSetGenres,
          artistSetReadableName,
          artistSlugName,
          artistSetSlugName,
          artistReadableName,
          countryCode,
          dateTimeEndReal,
          dateTimeStartReal,
          dateTimeStartHuman,
          duration,
          image,
          mediaLinks,
          postUri,
          shortTitle,
          show,
          smallText,
          venueSlugName,
          stock,
          timezone,
        },
        fetchPolicy: 'no-cache',
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { postAddArtistSet: postAddArtistSetValidationData },
    } = result;

    if (postAddArtistSetValidationData) {
      return postAddArtistSetValidationData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: postAddArtistSetValidationData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: postAddArtistSet Error: ${error}`);
    return null;
  }
};

export default postAddArtistSet;
